<template>
    <div style="height: 100%;overflow: auto">
        <div class="head-container">
            <Row>
                <Col span="6">
                    <div class="form-label">
                        <span>车牌号：</span>
                    </div>
                    <div class="form-input">
                        <Input v-model="formParam.carPlateNumber" @on-keyup="onPlateKeyUp"/>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>工单状态：</span>
                    </div>
                    <div class="form-input">
                        <Select v-model="formParam.status" filterable clearable>
                            <Option v-for="item in statusList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>客户名称：</span>
                    </div>
                    <div class="form-input">
                        <Input v-model="formParam.memberName"/>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>服务顾问：</span>
                    </div>
                    <div class="form-input">
                        <Select v-model="formParam.createUserId" filterable clearable>
                            <Option v-for="item in allUsers" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
            </Row>
            <Row style="margin-top: 15px">
                <Col span="6">
                    <div class="form-label">
                        <span>收车日期：</span>
                    </div>
                    <div class="form-input">
                        <div style="display: inline-block;width: 100%">
                            <DatePicker style="width: 100%" v-model="dateRange" format="yyyy-MM-dd"
                                        @on-change="dateChange"
                                        type="daterange" placement="bottom-end"
                                        placeholder="选择收车日期"/>
                        </div>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>结算员：</span>
                    </div>
                    <div class="form-input">
                        <Select v-model="formParam.settleUserId" filterable clearable>
                            <Option v-for="item in allUsers" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>收银员：</span>
                    </div>
                    <div class="form-input">
                        <Select v-model="formParam.cashierUserId" filterable clearable>
                            <Option v-for="item in allUsers" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="6">
                    <div class="form-label">
                        <span>收银时间：</span>
                    </div>
                    <div class="form-input">
                        <div style="display: inline-block;width: 100%">
                            <DatePicker style="width: 100%" v-model="cashierDateRange"
                                        format="yyyy-MM-dd" @on-change="cashierDateChange"
                                        type="daterange" placement="bottom-end"
                                        placeholder="选择收银日期"/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row style="margin-top: 15px">
                <Col span="18">
                    <div class="form-label">
                        <span>结算日期：</span>
                    </div>
                    <div style="display: inline-block">
                        <RadioGroup v-model="quickDate" type="button" @on-change="dateRadioChange">
                            <Radio label="三个月内"></Radio>
                            <Radio label="一个月内"></Radio>
                            <Radio label="15天内"></Radio>
                            <Radio label="7天内"></Radio>
                            <Radio label="3天内"></Radio>
                            <Radio label="当天"></Radio>
                            <Radio label="hide" style="display: none"></Radio>
                        </RadioGroup>
                    </div>
                    <div style="display: inline-block; width: auto;margin-left: 20px">
                        <span>自定义：</span>
                    </div>
                    <div style="display: inline-block">
                        <DatePicker v-model="settleDateRange" format="yyyy-MM-dd" @on-change="settleDateChange"
                                    type="daterange" placement="bottom-end"
                                    placeholder="选择结算日期"/>
                    </div>
                </Col>
                <Col span="6">
                    <div style="text-align: right">
                        <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
                        <Button icon="md-refresh" @click="reset">重置</Button>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="under-container">
            <Table :columns="columns" :data="tableData" size="small">
                <template #action="{ row, index }">
                    <span class="table-button-edit" v-if="row.status===3 || row.status===5"
                          @click="toOrderDetail(row)">详情</span>
                    <span class="table-button-edit" v-if="row.status===3"
                          style="margin-left: 5px;color: #05ad59" @click="toWriteOff(row)">销账</span>
                    <span class="table-button-edit" v-if="row.status===2" @click="toCashierDetail(row)">收款</span>
                    <Poptip
                        v-if="row.status===2"
                        confirm
                        title="确定取消结算?"
                        placement="top-end"
                        @on-ok="cancelSettlementClick(row)" transfer>
                        <span class="table-button-edit" style="margin-left: 5px;color: #f5ad14">取消结算</span>
                    </Poptip>
                    <Poptip
                        v-if="row.status===3 || row.status===5"
                        confirm
                        title="确定取消收银?"
                        placement="top-end"
                        @on-ok="cancelCashierClick(row)" transfer>
                        <span class="table-button-edit"
                              style="margin-left: 5px;color:#e82854">取消收款</span>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modalDetail"
            fullscreen
            :closable="false"
            footer-hide>
            <div style="height: 100%">
                <cashier-detail v-if="modalDetail" :orderInput="currentOrder" @handleClose="handleCashierClose"></cashier-detail>
            </div>
        </Modal>
        <Modal
            v-model="modalOrderDetail"
            fullscreen
            :closable="false"
            footer-hide>
            <div style="height: 100%; overflow: auto;margin-top: -10px">
                <order-detail v-if="modalOrderDetail" :orderInput="currentOrder" @handleClose="handleDetailClose"></order-detail>
            </div>
        </Modal>
        <Modal
            title="销账"
            draggable
            sticky
            :closable="false"
            footer-hide
            :mask-closable="false"
            v-model="writeOffModal">
            <Form :model="formWriteOff" ref="formWriteOff" :rules="rules">
                <FormItem label="挂账金额" style="margin-bottom: 0;">
                    <span style="color: #e82854">￥{{ currentOrder.creditPrice }}</span>
                </FormItem>
                <FormItem label="销账金额" prop="writeOffPrice" style="margin-bottom: 0;">
                    <Input v-model="formWriteOff.writeOffPrice" placeholder="请输入本次销账金额"></Input>
                </FormItem>
                <FormItem label="支付方式" prop="payMethod" style="margin-bottom: 0;">
                    <Select v-model="formWriteOff.payMethod" filterable placeholder="请选择支付方式">
                        <Option v-for="item in payMethods" :value="item.id" :key="item.id">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                <div style="text-align: right;margin-top: 20px">
                    <Button style="margin-right: 10px" @click="cancelWriteOff()">取消</Button>
                    <Button type="primary" @click="okWriteOff()">确定销账</Button>
                </div>
            </Form>
        </Modal>
    </div>
</template>

<script>

import {cancelCashier, cancelSettleOrder, queryCashierWorkOrder, queryStoreAllUser, saveCashierWorkOrder, writeOff} from "@/api/business"
import CashierDetail from "@/components/Business/CashierDetail"
import OrderDetail from "@/components/Business/OrderDetail"

export default {
    name: "OrderCashier",
    components: {
        CashierDetail,
        OrderDetail,
    },
    data() {
        return {
            formParam: {
                carPlateNumber: '',
                status: '',
                memberName: '',
                current: 1,
                size: 20,
                total: 0,
                settleUserId: '',
                createUserId: '',
                settleTime: undefined,
                endSettleTime: undefined,
                cashierUserId: '',
                cashierTime: undefined,
                endCashierTime: undefined,
                createTime: undefined,
                updateTime: undefined,
            },
            writeOffPrice: '',
            writeOffModal: false,
            dateRange: [],
            settleDateRange: [],
            cashierDateRange: [],
            statusList: [{
                id: '',
                name: '全部',
            }, {
                id: '2',
                name: '待付款',
            }, {
                id: '3',
                name: '已挂账',
            }, {
                id: '5',
                name: '已完成',
            }],
            quickDate: '三个月内',
            tableData: [],
            currentOrder: {},
            columns: [
                {
                    title: '车牌号',
                    key: 'carPlateNumber',
                    width: 120,
                    fixed: 'left',
                    align: 'center',
                },
                {
                    title: '客户名称',
                    key: 'memberName',
                    minWidth: 120,
                    fixed: 'left',
                    align: 'center',
                },
                {
                    title: '状态',
                    key: 'status',
                    width: 100,
                    render: this.renderStatus,
                    align: 'center',
                },
                {
                    title: '收车时间',
                    key: 'createTime',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: '结算时间',
                    key: 'settleTime',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: '收银时间',
                    key: 'cashierTime',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: '结算员',
                    key: 'settleUserName',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '结算金额',
                    key: 'receivablePrice',
                    width: 120,
                    align: 'center',
                    render: this.renderReceivablePrice,
                },
                {
                    title: '收银员',
                    key: 'cashierUserName',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '实收金额',
                    key: 'actualPrice',
                    width: 120,
                    align: 'center',
                    render: this.renderActualPrice,
                },
                {
                    title: '挂账金额',
                    key: 'creditPrice',
                    width: 120,
                    align: 'center',
                    render: this.renderCreditPrice,
                },
                {
                    title: '减免金额',
                    key: 'reducePrice',
                    width: 120,
                    align: 'center',
                    render: this.renderReducePrice,
                },
                {
                    title: '开票金额',
                    key: 'invoicePrice',
                    width: 120,
                    align: 'center',
                    render: this.renderInvoicePrice,
                },
                {
                    title: '维修分类',
                    key: 'classifyName',
                    align: 'center',
                    width: 120,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                    fixed: 'right',
                },
            ],
            modalDetail: false,
            modalOrderDetail: false,
            allUsers: [],
            formWriteOff: {
                orderId: '',
                writeOffPrice: '',
                payMethod: '',
            },
            rules: {
                writeOffPrice: [
                    {required: true, message: '销账金额不能为空', trigger: 'blur'},
                ],
                payMethod: [
                    {required: true, message: '请选择支付方式', trigger: 'change'},
                ],
            },
            payMethods: [{
                id: "1",
                text: '微信支付',
            }, {
                id: "2",
                text: '支付宝支付',
            }, {
                id: "3",
                text: '现金支付',
            }, {
                id: "4",
                text: '刷卡支付',
            }, {
                id: "5",
                text: '余额支付',
            }],
        }
    },
    mounted() {
        this.queryAllUser()
        let {start, end} = this.getDateRange(90)
        this.formParam.settleTime = start
        this.formParam.endSettleTime = end
        this.onQuery()
    },
    methods: {
        queryAllUser() {
            queryStoreAllUser().then((res) => {
                this.allUsers = res.data
                this.allUsers.unshift({id: '', name: "全部"})
            })
        },
        onPlateKeyUp() {
            this.formParam.carPlateNumber = this.formParam.carPlateNumber.toUpperCase()
        },
        reset() {
            this.formParam = {
                carPlateNumber: '',
                status: '',
                memberName: '',
                current: 1,
                size: 20,
                total: 0,
                settleUserId: '',
                createUserId: '',
                settleTime: undefined,
                endSettleTime: undefined,
                cashierUserId: '',
                cashierTime: undefined,
                endCashierTime: undefined,
                createTime: undefined,
                updateTime: undefined,
            }
            this.dateRange = []
            this.settleDateRange = []
            this.cashierDateRange = []
        },
        onQuery() {
            if (this.formParam.carPlateNumber !== '') {
                this.formParam.createTime = undefined
                this.formParam.updateTime = undefined
            }
            queryCashierWorkOrder(this.formParam).then((res) => {
                this.tableData = res.data
                this.formParam.total = res.total
            })
        },
        cashierDateChange(range) {
            if (range.length > 1) {
                if (range[0].length > 1 && range[1].length > 1) {
                    this.formParam.cashierTime = range[0] + " 00:00:00"
                    this.formParam.endCashierTime = range[1] + " 23:59:59"
                    this.onQuery()
                } else {
                    this.formParam.cashierTime = undefined
                    this.formParam.endCashierTime = undefined
                }
            } else {
                this.formParam.cashierTime = undefined
                this.formParam.endCashierTime = undefined
            }
        },
        settleDateChange(range) {
            if (range.length > 1) {
                if (range[0].length > 1 && range[1].length > 1) {
                    this.formParam.settleTime = range[0] + " 00:00:00"
                    this.formParam.endSettleTime = range[1] + " 23:59:59"
                    this.onQuery()
                } else {
                    this.formParam.settleTime = undefined
                    this.formParam.endSettleTime = undefined
                }
            } else {
                this.formParam.settleTime = undefined
                this.formParam.endSettleTime = undefined
            }
        },
        dateChange(range) {
            if (range.length > 1) {
                if (range[0].length > 1 && range[1].length > 1) {
                    this.formParam.createTime = range[0] + " 00:00:00"
                    this.formParam.updateTime = range[1] + " 23:59:59"
                    this.onQuery()
                    this.quickDate = 'hide'
                } else {
                    this.formParam.createTime = undefined
                    this.formParam.updateTime = undefined
                }
            } else {
                this.formParam.createTime = undefined
                this.formParam.updateTime = undefined
            }
        },
        dateRadioChange(e) {
            this.formParam.settleTime = undefined
            this.formParam.endSettleTime = undefined
            this.settleDateRange = []
            let day = 1
            switch (e) {
                case 'hide':
                    return
                case '当天':
                    day = 1
                    break
                case '3天内':
                    day = 3
                    break
                case '7天内':
                    day = 7
                    break
                case '15天内':
                    day = 15
                    break
                case '一个月内':
                    day = 30
                    break
                case '三个月内':
                    day = 90
                    break
                default:
                    day = 1
            }
            let {start, end} = this.getDateRange(day)
            this.formParam.settleTime = start
            this.formParam.endSettleTime = end
            this.onQuery()
        },
        getDateRange(day) {
            const end = new Date()
            end.setHours(23, 59, 59, 999)

            const start = new Date()
            start.setDate(start.getDate() - (day - 1)) // 3天包括今天，所以减2
            start.setHours(0, 0, 0, 0)

            return {
                start: this.formatDate(start),
                end: this.formatDate(end),
            }
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },
        getStatusName(status) {
            switch (status) {
                case 0:
                    return '已接车'
                case 1:
                    return '维修中'
                case 2:
                    return '待付款'
                case 5:
                    return '已完成'
                default:
                    return '未知车辆'
            }
        },
        renderStatus(h, param) {
            switch (param.row.status) {
                case 0:
                    return h('span', '已接车')
                case 1:
                    return h('span', '维修中')
                case 2:
                    return h('div', {
                        style: {
                            background: '#f5ad14',
                            color: '#ffffff',
                            padding: '3px 8px',
                            borderRadius: '3px',
                        },
                    }, '待付款')
                case 3:
                    return h('div', {
                        style: {
                            background: '#e82854',
                            color: '#ffffff',
                            padding: '3px 8px',
                            borderRadius: '3px',
                        },
                    }, '已挂账')
                case 5:
                    return h('div', {
                        style: {
                            background: '#5cb85c',
                            color: '#ffffff',
                            padding: '3px 8px',
                            borderRadius: '3px',
                        },
                    }, '已完成')
                default:
                    return h('span', '未知车辆')
            }
        },
        renderReceivablePrice(h, param) {
            let value = param.row.receivablePrice ? param.row.receivablePrice : 0.00
            return h('span', {
                style: {
                    color: '#e12513',
                },
            }, '￥' + value)
        },
        renderCreditPrice(h, param) {
            let value = param.row.creditPrice ? param.row.creditPrice : 0.00
            return h('span', '￥' + value)
        },
        renderReducePrice(h, param) {
            let value = param.row.reducePrice ? param.row.reducePrice : 0.00
            return h('span', '￥' + value)
        },
        renderActualPrice(h, param) {
            let value = param.row.actualPrice ? param.row.actualPrice : 0.00
            return h('span', {
                style: {
                    color: '#0eab08',
                },
            }, '￥' + value)
        },
        renderInvoicePrice(h, param) {
            let value = param.row.invoicePrice ? param.row.invoicePrice : 0.00
            return h('span', '￥' + value)
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        toCashierDetail(row) {
            this.currentOrder = row
            this.modalDetail = true
        },
        toOrderDetail(row) {
            this.currentOrder = row
            this.modalOrderDetail = true
        },
        toWriteOff(row) {
            this.currentOrder = row
            this.writeOffModal = true
            this.formWriteOff = {
                orderId: row.id,
                writeOffPrice: '',
                payMethod: '',
            }
        },
        handleDetailClose(data) {
            if (data) {
                // todo
            }
            this.modalOrderDetail = false
        },
        handleCashierClose(data) {
            if (data) {
                saveCashierWorkOrder(data).then(() => {
                    this.modalDetail = false
                    this.$Message.success({
                        background: true,
                        content: '收银完成',
                    })
                    this.onQuery()
                })
            } else {
                this.modalDetail = false
            }
        },
        cancelSettlementClick(row) {
            cancelSettleOrder(row).then(() => {
                this.onQuery()
                this.$Message.success({
                    background: true,
                    content: '取消结算完成',
                })
            })
        },
        cancelCashierClick(row) {
            cancelCashier(row).then(() => {
                this.onQuery()
                this.$Message.success({
                    background: true,
                    content: '取消收银完成',
                })
            })
        },
        cancelWriteOff() {
            this.writeOffModal = false
        },
        okWriteOff() {
            this.$refs.formWriteOff.validate((valid) => {
                if (valid) {
                    writeOff(this.formWriteOff).then(() => {
                        this.onQuery()
                        this.$Message.success({
                            background: true,
                            content: '销账完成',
                        })
                        this.writeOffModal = false
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-label {
    display: inline-block;
    font-weight: bold;
    text-align: right;
    width: 80px;
}

.form-input {
    display: inline-block;
    width: calc(100% - 80px);
}

.under-container {
    margin: 10px;
    background: #ffffff;
    padding: 10px;
    text-align: left;
}

</style>
